import { Action, createReducer, on, createSelector, createFeatureSelector } from '@ngrx/store';
import { Avatar } from '../../models/avatar.model';
import * as MenuActions from '../actions/menu.actions';


export const menuFeatureKey = 'menu';

export interface MenuState {
  user: Avatar;
}

export const initialState: MenuState = {
  user: {
    displayName: '',
    role: '',
    code: ''
  }
};

const menuReducer = createReducer(
  initialState,
  on(MenuActions.setUserMenu, (state, { user }) => ({ user }))
);

export function reducer(state: MenuState | undefined, action: Action) {
  return menuReducer(state, action);
}
